// MyProvider.tsx
import React, { Component } from 'react';
import UserDetailsContext from './TableContext';
// import store from '../../../../store/store';
// import * as helpers from '../helpers';
// import { GENERAL } from '../config/Transaction/TransactionGeneralConf'

/**
 * @param startPage always should be 0 when it comes to 1st page since react-pagination require 1st page to be index = 0
 */

class UserDetailsProvider extends Component {

  primaryMemory = {

  }

  state = {
    primaryMemory: this.primaryMemory
  };

  prevState = [];

  render() {
    const contextValue = {
      primaryMemory: this.state.primaryMemory
    };

    return <UserDetailsContext.Provider value={contextValue}>{this.props.children}</UserDetailsContext.Provider>;
  }
}

export default UserDetailsProvider;
